module.exports = __webpack_public_path__ + "media/logos/crains-logo-white-93757255.png";